import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AssessmentService } from "../assessment.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-evaluator",
  standalone: false,
  templateUrl: "./evaluator.component.html",
  styleUrl: "./evaluator.component.css",
})
export class EvaluatorComponent {
  searchList = [
    { name: "Evaluator Name", value: "name" },
    { name: "Profile Tag", value: "tag" },
  ];
  allSelected: boolean = false;
  searchForm: FormGroup;
  isLoadmore: Boolean = true;
  companyId: any;
  accessToken: any;
  evaluationStageList: any[] = [];
  evaluators: any[] = [];
  batchDetails: any;
  noDataFoundFlag: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EvaluatorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private assessmentService: AssessmentService,
    private ngxService: NgxUiLoaderService,
    private toastrService: ToastrService
  ) {
    this.accessToken = localStorage.getItem("accessToken");
    this.companyId = localStorage.getItem("companyId");
    this.batchDetails = data;
    this.searchForm = this.fb.group({
      type: ["tag"],
      text: [""],
    });
  }

  ngOnInit() {
    this.getAvailableEvaluator();
  }

  clearSearch() {
    this.searchForm.get("text").setValue("");
    this.getAvailableEvaluator();
  }

  toggleAll() {
    this.evaluators.forEach((item) => {
      item.isSelected = this.allSelected;
    });
  }

  updateSelection() {
    this.allSelected = this.evaluators.every((item) => item.isSelected);
  }

  closeModal() {
    this.dialogRef.close(false);
  }

  getAvailableEvaluator() {
    let formData = this.searchForm.value;
    this.ngxService.start();
    const payload = {
      linkId: this.batchDetails.linkId,
      searchBy: formData.type,
      searchText: formData.text,
    };
    this.assessmentService
      .getAvailableEvaluator(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          this.evaluators = response.message;
          this.noDataFoundFlag = false;
          this.ngxService.stop();
        },
        (error) => {
          this.evaluators = [];
          this.noDataFoundFlag = true;
          this.toastrService.error(error.error.message);
          this.ngxService.stop();
        }
      );
    this.allSelected = false;
  }

  assignEvaluator() {
    this.ngxService.start();
    const selectedEvaluatorIds = this.evaluators
      .filter((e) => e?.isSelected)
      .map((e) => e?._id);

    const payload = {
      linkId: this.batchDetails.linkId,
      stageId: this.batchDetails.stageId,
      evaluatorIds: selectedEvaluatorIds,
    };
    this.assessmentService
      .assignEvaluator(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          this.evaluators = response.message;
          this.dialogRef.close(true);
          this.ngxService.stop();
        },
        (error) => {
          this.evaluators = [];
          this.toastrService.error(error.error.message);
          this.dialogRef.close(false);
          this.ngxService.stop();
        }
      );
    this.allSelected = false;
  }

  isAnyEvaluatorSelected(): boolean {
    return this.evaluators.some((e) => e.isSelected);
  }
}
